// extracted by mini-css-extract-plugin
export var acitonButtons = "_m4-0";
export var additionalIcon = "_m4-f";
export var block = "_m4-1";
export var blockContent = "_m4-7";
export var blockDescription = "_m4-8";
export var blockIcon = "_m4-9";
export var blockTitle = "_m4-6";
export var border = "_m4-a";
export var center = "_m4-l";
export var edge = "_m4-b";
export var edgeLabel = "_m4-c";
export var edgePath = "_m4-d";
export var error = "_m4-e";
export var flowchart = "_m4-g";
export var flowchartContent = "_m4-h";
export var highlighted = "_m4-3";
export var hover = "_m4-4";
export var icon = "_m4-i";
export var left = "_m4-m";
export var navButton = "_m4-j";
export var navButtons = "_m4-k";
export var right = "_m4-n";
export var selected = "_m4-2";
export var small = "_m4-5";